

export default {
  path: '/testpage',
  name: 'testpage',
  component: () => import('@/view/testpage/index.vue'),
  meta: {
    name: '测试页面'
  }
};
